import {
  OrderTotalContent,
  SubTotalText,
  TextContent,
  TotalPrice
} from './order-totals.styled'
import { OrderType } from '../../../types'
import { currencyFormatted } from '@yuno/sdk-web-core/dist/utils'
import { useTranslation } from 'react-i18next'

export const OrderTotals: React.FC<OrderType.Total> = ({ totalDue, currency }) => {
  const { t } = useTranslation()

  return (
    <OrderTotalContent>
      <TextContent>
        <SubTotalText>{t('Total due')}</SubTotalText>
        <TotalPrice>{currencyFormatted(currency, totalDue)} {currency}</TotalPrice>
      </TextContent>
    </OrderTotalContent>
  )
}
